import React from "react";
import { DisplayLogs } from "./DisplayLogs";
import { SendTestEnvelopeForm } from "./SendTestEnvelopeForm";
import { useEffect } from "react";
import { connect } from "react-redux";
import { set_page } from "../../store/actions/utils/page";
import { set_db_data } from "../../store/actions/utils/db_data";

const DocusignTestComponent = (props) => {
  useEffect(() => {
    props.set_page("docusign-admin");
    props.set_db_data({
      ...props.db_data,
      title: "Docusign Test",
      sort_btn: false,
      add_btn: false,
    });
  }, [props, props.set_page, props.set_db_data]);

  return (
    <div className="container1">
      <div
        style={{
          padding: "2rem",
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
          width: "100%",
          height: "100%",
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: 8,
            padding: "2rem",
            width: "300px",
          }}
        >
          <div>
            <span>Docusign Test</span>
          </div>
          <div style={{ marginTop: 8 }}>
            <SendTestEnvelopeForm />
          </div>
          <div></div>
        </div>
        <div
          style={{
            background: "white",
            borderRadius: 8,
            padding: "2rem",
            flex: 1,
            maxHeight: "100%",
            overflowY: "auto",
          }}
        >
          <DisplayLogs />
        </div>
      </div>
    </div>
  );
};

export const DocusignTest = connect(() => {}, { set_page, set_db_data })(
  DocusignTestComponent
);
